export default __webpack_public_path__ + "static/media/brillo.b019c4cb.png";